// MUI
import SpecialPages from "@Layouts/components/SpecialPages";
// Image
import NotFoundImage from "@/assets/images/notFound/404.png";

const NotFound = () => {
	const title = (
		<>
			Page <br /> Not Found
		</>
	);
	const desc = "The page you’re looking for couldn’t be found. Click the button below to go back to the dashboard.";
	const imageAlt = "Page Not Found";
	const imgBoxClasses = "mt-[54px] mr-[218px]";
	return <SpecialPages title={title} description={desc} image={NotFoundImage} imageAlt={imageAlt} imgBoxClasses={imgBoxClasses} />;
};

export default NotFound;
